<template>
    <div class="flex-fill flex-column">
        <request-list
            v-if="activePage.show === 'index'"
            @show-details="showDetails"
        />

        <query-detail
            v-if="activePage.show === 'detail' && selectedHeader"
            :header="selectedHeader"
            :detailItems="detailItems"
        />
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import RequestList from './RequestList.vue'
    import QueryDetail from './QueryDetail.vue'

    export default {
        name: 'ManageNlfLogs',
        components: {
            RequestList,
            QueryDetail
        },
        computed: {
            ...mapState('manage', ['breadcrumbs']),
            activePage() {
                let b = this.breadcrumbs['NLF Logs']
                return b[b.length - 1]
            }
        },
        data() {
            return {
                selectedHeader: null,
                detailItems: []
            }
        },
        methods: {
            showDetails(request) {
                this.selectedHeader = request
                this.detailItems = []
                this.$store.commit('manage/addCrumb', {
                    key: 'NLF Logs',
                    val: { name: 'Log Detail', show: 'detail' }
                })
                this.$modelGet('nlfLogQueryDetail', { query_id: request.query_id })
                    .then(data => {
                        this.selectedHeader = {
                            ...request,
                            session_id: data.header?.session_id,
                            model_id: data.queries?.[0]?.model_id
                        }
                        // Feedback (rating + comment) is recorded once per query. Carry it onto the
                        // query's detail iterations and flag the last one so the detail view can
                        // render a single Feedback section beneath that iteration's Output rows.
                        this.detailItems = (data.queries || []).flatMap(q => {
                            let details = q.details || []
                            return details.map((detail, i) => ({
                                ...detail,
                                queryRating: q.rating,
                                queryFeedbackText: q.feedback_text,
                                showFeedback: i === details.length - 1
                            }))
                        })
                    })
                    .catch(err => {
                        console.error('Failed to load query details:', err)
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
